const DEFAULT_HOST = "https://public-assets.ambifi.com";
const LOCAL_HOST = "https://local.ambifi.com:3002";

const ORG_SLUGS = {
	"332a9d47-6e36-11e8-a392-061714f61e3e": "jab",
	"a25f9e42-23cd-11ec-9068-066917b38554": "ich"
};

// The company code the pricer understands (?companyCode=). JAB's project slug is "jab"
// but its pricer company is Converge Custom, "cc".
const SLUG_COMPANY_CODES = {
	jab: "cc",
	ich: "ich"
};

const normalizeHost = (host = DEFAULT_HOST) => host.replace(/\/$/, "");

export const getPricerCompanyCode = (orgId) => {
	const slug = ORG_SLUGS[String(orgId || "").trim().toLowerCase()];
	return slug ? SLUG_COMPANY_CODES[slug] || null : null;
};

export const createPricerUrlMap = (host = DEFAULT_HOST) => {
	const base = normalizeHost(host);
	return Object.entries(ORG_SLUGS).reduce((acc, [orgId, slug]) => {
		acc[orgId] = `${base}/projects/${slug}/pricer/index.html`;
		return acc;
	}, {});
};

const PRICER_URLS = createPricerUrlMap();

const isLocalHostname = (hostname = "") => {
	const normalized = hostname.toLowerCase();
	return normalized.includes("local.") || normalized.includes("localhost");
};

const shouldForceRemoteHost = () => {
	if (typeof window === "undefined") {
		return false;
	}
	if (window.__AMBIFI_FORCE_REMOTE_PRICER__ === true) {
		return true;
	}
	if (window.defaultParams && window.defaultParams.forceRemotePricer === true) { // eslint-disable-line no-undef
		return true;
	}
	return false;
};

export const createRuntimePricerUrlResolver = ({
	defaultMap = PRICER_URLS,
	localHost = LOCAL_HOST
} = {}) => {
	let cachedLocalMap = null;

	const getRuntimeMap = () => {
		if (typeof window === "undefined" || !window.location) {
			return defaultMap;
		}
		if (shouldForceRemoteHost()) {
			return defaultMap;
		}
		if (isLocalHostname(window.location.hostname || "")) {
			if (!cachedLocalMap) {
				cachedLocalMap = createPricerUrlMap(localHost);
			}
			return cachedLocalMap;
		}
		return defaultMap;
	};

	return (orgId) => {
		if (!orgId) {
			return null;
		}
		const runtimeMap = getRuntimeMap();
		return runtimeMap[orgId] || defaultMap[orgId] || null;
	};
};

export const getRuntimePricerUrl = createRuntimePricerUrlResolver();

export default PRICER_URLS;
